export const AREA_USE_PURPOSE_DATA_SOURCE = {
  CITY_PLANNING: "city_planning_decision_gis_data",
  NATIONAL_LAND: "national_land_numerical_information",
} as const;

export type AreaUsePurposeDataSource =
  (typeof AREA_USE_PURPOSE_DATA_SOURCE)[keyof typeof AREA_USE_PURPOSE_DATA_SOURCE];
